import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'usb-blickoins',
  template: `
           <div class="d-flex align-items-center  px-3" style="height:67px;" [ngStyle]="{'border-top': categoryId !== 5 ? '.5px solid ' + stylePathPrice?.card_line : '.5px solid #cccccc'}">
             <img
                src="../../../../../assets/icons/search-result/BLICKOIS-01.svg"
                width="28px"
                height="28px"
                alt=""
                class="mr-1 ml-2"
              />
              <div>
                <p class="ml-1 mb-0 rubik-regular-12pt" style="line-height: 1;color: black">
                 Sumás
                </p>
                 <p class="ml-1 mb-0 rubik-regular-12pt" style="font-weight: 500; color: #fec039">
                  {{ blickoins  | number : "1.2-2" }} BKS
                </p>
              </div>
          </div>
  `,
  styleUrls: ['../base-result.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BlickoinsComponent implements OnInit {

  @Input() blickoins: any;
  @Input() stylePathPrice: any;
  @Input() categoryId!: number;

  constructor() { }

  ngOnInit(): void {
  }

}
